// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2aIeQ","upload":"Small_upload__JGRlg","imageWrap":"Small_imageWrap__-ULnY","removeBtn":"Small_removeBtn__31cMG"};